<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import headers from "@/components/headers";
import axiosCatch from "@/components/axios-catch"
import RegistroContato from "@/components/widgets/registro-contato";
import Multiselect from "vue-multiselect";
import DatatableCustom from "@/components/widgets/datatable-custom.vue";

/**
 * Wallets component
 */
export default {
  page: {
    title: "Alunos por Disciplina",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    RegistroContato,
    Multiselect,
    DatatableCustom
  },
  data() {
    return {
      filterOn: [],
      relatorio: [],
      filtros: {},
      cursos: [],
      disciplinas: [],
      situacoes: [],
      form: {
        situacao: null,
        curso: null,
        disciplina: null,
        periodoLetivo: null,
        id: null,
      },
      title: "Alunos por Disciplina",
      buscandoFiltros: false,
      buscando: false,
      jaBuscou: false,
      aluno: { nome: null },
      modalAluno: false,
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Gestão Acadêmica",
          href: "#",
        },
        {
          text: "Alunos por Disciplinas",
          active: true,
        },
      ],
      fields: [
        {
          key: 'tipo',
          label: 'Tipo',
          sortable: true,
        },
        {
          key: "unidade",
          label: 'Unidade',
          sortable: true,
        },
        {
          key: "username",
          label: 'Usuário',
          sortable: true,
        },
        {
          key: 'ra',
          label: 'RA',
          sortable: true,
        },
        {
          key: 'situacao',
          label: 'Situação',
          sortable: true,
        },
        {
          key: 'situacaoDisciplina',
          label: 'Situação na disciplina',
          sortable: true,
        },
        {
          key: 'polo',
          label: 'Polo',
          sortable: true,
        },
        {
          key: 'disciplina',
          label: 'Disciplina',
          sortable: true,
        },
        {
          key: 'curso',
          label: 'Curso',
          sortable: true,
        },
        {
          key: 'corTurma',
          label: 'Código turma',
          sortable: true,
        },
        {
          key: 'codPerLet',
          label: 'Período letivo',
          sortable: true,
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'cpf',
          label: 'CPF',
          sortable: true,
        },
        {
          key: 'dataNascimento',
          label: 'Data de nascimento',
          sortable: true,
        },
        {
          key: 'email',
          label: 'E-mail',
          sortable: true,
        },
        {
          key: 'telefone1',
          label: 'Telefone 1',
          sortable: true,
        },
        {
          key: 'telefone2',
          label: 'Telefone 2',
          sortable: true,
        },
        {
          key: 'telefone3',
          label: "Telefone 3",
          sortable: true,
        },
      ]
    };
  },
  mounted() {
    this.buscarFiltros()
  },
  methods: {
    prepararCursos() {
      this.cursos = []
      this.form.curso = null
      this.disciplinas = []
      this.form.disciplina = null
      this.situacoes = []
      this.form.situacao = null
      this.cursos = Object.keys(this.filtros[this.form.periodoLetivo])
    },
    prepararDisciplinas() {
      this.disciplinas = []
      this.form.disciplina = null
      this.situacoes = []
      this.form.situacao = null
      this.disciplinas = Object.keys(this.filtros[this.form.periodoLetivo][this.form.curso])
    },
    prepararSituacao() {
      this.situacoes = []
      this.form.situacao = null
      this.situacoes = this.filtros[this.form.periodoLetivo][this.form.curso][this.form.disciplina]
    },
    limparForm() {
      this.form = {
        situacao: null,
        curso: null,
        disciplina: null,
        periodoLetivo: null,
        id: null,
      }
      this.cursos = []
      this.disciplinas = []
      this.situacoes = []
    },
    limparDisciplina() {
      this.form.disciplina = null
    },
    buscarFiltros() {
      this.buscandoFiltros = true
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/gestao_academica/aluno_por_disciplina/filtros",
          {
            headers: headers,
          }
        )
        .then((response) => {
          this.filtros = response.data
        })
        .catch((error) => {
          axiosCatch(error)
        })
        .finally(() => {
          this.buscandoFiltros = false
        })
    },
    gerarRelatorio() {
      this.buscando = true
      this.jaBuscou = true
      this.relatorio = []
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/gestao_academica/aluno_por_disciplina",
          {
            headers: headers,
            params: this.form
          }
        )
        .then((response) => {
          this.relatorio = response.data
          this.totalRows = response.data.length
        })
        .catch((error) => {
          axiosCatch(error)
        })
        .finally(() => {
          this.buscando = false
        })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="buscandoFiltros">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Buscando filtros...
          </div>
          <div class="card-body" v-else>
            <form @submit.prevent="gerarRelatorio">
              <div class="row">
                <div class="col-md-6">
                  <div role="group" class="form-group mb-3">
                    <label class="d-block">Período Letivo</label>
                    <div>
                      <multiselect v-model="form.periodoLetivo" :options="Object.keys(filtros)" class="helo"
                        placeholder="Selecione uma opção" @input="prepararCursos">
                        <template slot="option" slot-scope="{ option }">
                          {{ option + ' - ' + (option.includes('/') ? 'Graduação' : 'Pós Graduação') }}
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div role="group" class="form-group mb-3">
                    <label class="d-block">Cursos</label>
                    <div>
                      <multiselect v-model="form.curso" :options="cursos" class="helo" placeholder="Selecione uma opção"
                        @input="prepararDisciplinas"></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div role="group" class="form-group mb-3">
                    <label class="d-block">Disciplinas</label>
                    <div>
                      <multiselect v-model="form.disciplina" :options="disciplinas" class="helo"
                        placeholder="Selecione uma opção" @input="prepararSituacao"></multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div role="group" class="form-group mb-3">
                    <label class="d-block">Situação na disciplina</label>
                    <div>
                      <multiselect v-model="form.situacao" :options="situacoes" class="helo"
                        placeholder="Selecione uma opção"></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div role="group" class="form-group mb-3">
                    <label class="d-block">Buscar por Nome / CPF / Código de Usuário</label>
                    <div>
                      <input class="form-control" v-model="form.id" autocomplete="off" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="button-items">
                <button type="submit" class="btn btn-primary" :disabled="buscando" @click="gerarRelatorio">
                  <i class="bx bx-search font-size-16 align-middle me-2"></i>
                  {{ (buscando ? 'Buscando...' : 'Buscar') }}
                </button>
                <button type="button" class="btn btn-warning" @click="limparForm">
                  <i class="bx bx-x font-size-16 align-middle me-2"></i>
                  Limpar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="jaBuscou">
      <div class="col-12" v-if="buscando">
        <div class="card">
          <div class="card-body">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Buscando...
          </div>
        </div>
      </div>
      <DatatableCustom v-else :filterOn="filterOn" :items="relatorio" :fields="fields" :jaBuscou="jaBuscou">
      </DatatableCustom>
    </div>
    <b-modal v-model="modalAluno" size="xl" :title="aluno.nome" title-class="font-18" hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-comment"></i>
                </span>
                <span class="d-none d-sm-inline-block">Registro de Contato</span>
              </template>
              <RegistroContato :aluno="aluno" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
